// import { useState, useEffect, useRef } from "react";
// import { Link } from "react-router-dom";
// import axios from "axios";
// import ReactPaginate from "react-paginate";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import Swal from "sweetalert2";

// const UsersList = () => {
//     // ---------- state & refs (always declared unconditionally) ----------
//     const [data, setData] = useState([]);
//     const [filteredData, setFilteredData] = useState([]);
//     const [currentPage, setCurrentPage] = useState(0);
//     const [itemsPerPage, setItemsPerPage] = useState(10);
//     const [searchQuery, setSearchQuery] = useState("");
//     const [activeTab, setActiveTab] = useState("all"); // 'all' | 'approve' | 'pending' | 'rejected'
//     const [selectedIds, setSelectedIds] = useState([]); // selected pending/rejected ids
//     const headerChkRef = useRef(null);

//     // ---------- helper: get unique id (backend might use id/_id/user_id) ----------
//     const getId = (u) => u?.id ?? u?._id ?? u?.user_id ?? null;

//     // ---------- robust rejected detection ----------
//     const isRejectedUser = (user) => {
//         if (!user) return false;

//         if (user?.rejected === true) return true;
//         if (user?.is_rejected === true) return true;

//         const maybe = (v) => v === 1 || v === "1" || v === "yes" || v === "true";
//         if (maybe(user?.rejected) || maybe(user?.is_rejected)) return true;

//         const s = (user?.status ?? "").toString().toLowerCase();
//         if (s.includes("reject")) return true;
//         if (s === "rejected") return true;

//         const other = (user?.approval_status ?? user?.approval ?? "")
//             .toString()
//             .toLowerCase();
//         if (other.includes("reject") || other === "rejected") return true;

//         return false;
//     };

//     // ---------- fetch data ----------
//     const getData = async () => {
//         try {
//             const res = await axios.get(
//                 `${process.env.REACT_APP_BACKEND_BASE_URL}/user/all`,
//             );
//             if (res.status === 200) {
//                 setData(res.data.data || []);
//             } else {
//                 setData([]);
//             }
//         } catch (err) {
//             console.log(err);
//             setData([]);
//         }
//     };

//     useEffect(() => {
//         getData();
//     }, []);

//     // ---------- status match helper ----------
//     const matchesStatus = (user, tab) => {
//         const uccRaw = user?.ucc ?? user?.UCC ?? null;

//         const uccEmpty =
//             uccRaw === null ||
//             uccRaw === undefined ||
//             (typeof uccRaw === "string" && uccRaw.trim() === "");

//         const isRejected = uccRaw === "Reject";
//         const isApproved = !uccEmpty && uccRaw !== "Reject";

//         if (tab === "all") return true;
//         if (tab === "approve") return isApproved;
//         if (tab === "pending") return uccEmpty;
//         if (tab === "rejected") return isRejected;

//         return true;
//     };

//     // ---------- filter by tab + search (runs whenever data/search/tab changes) ----------
//     useEffect(() => {
//         const q = (searchQuery || "").trim().toLowerCase();
//         const result = (data || []).filter((item) => {
//             if (!matchesStatus(item, activeTab)) return false;
//             if (!q) return true;
//             const first = (item.first_name || "").toString().toLowerCase();
//             const last = (item.last_name || "").toString().toLowerCase();
//             const email = (item.email || "").toString().toLowerCase();
//             return first.includes(q) || last.includes(q) || email.includes(q);
//         });

//         setFilteredData(result);
//         setCurrentPage(0);

//         // if switching away from pending or rejected, clear selectedIds to avoid stale selections
//         if (activeTab !== "pending" && activeTab !== "rejected") {
//             setSelectedIds([]);
//         }
//     }, [data, searchQuery, activeTab]);

//     // ---------- derive pagination values ----------
//     const indexOfLastItem = (currentPage + 1) * itemsPerPage;
//     const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//     const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
//     const pageCount = Math.ceil((filteredData.length || 0) / itemsPerPage);

//     // ---------- selection helpers ----------
//     const toggleRow = (id) => {
//         if (!id) return;
//         setSelectedIds((prev) => {
//             const set = new Set(prev);
//             if (set.has(id)) set.delete(id);
//             else set.add(id);
//             return Array.from(set);
//         });
//     };

//     // Toggle select all for current filteredData (used for both pending & rejected tabs)
//     const toggleSelectAll = () => {
//         const idsOnPage = filteredData.map((u) => getId(u)).filter(Boolean);
//         if (idsOnPage.length === 0) {
//             setSelectedIds([]);
//             return;
//         }
//         const allSelected = idsOnPage.every((pid) => selectedIds.includes(pid));
//         if (allSelected) {
//             // unselect all that are currently visible
//             setSelectedIds((prev) => prev.filter((id) => !idsOnPage.includes(id)));
//         } else {
//             // add all visible ids
//             setSelectedIds((prev) => {
//                 const set = new Set(prev);
//                 idsOnPage.forEach((p) => set.add(p));
//                 return Array.from(set);
//             });
//         }
//     };

//     // Keep header checkbox state (checked / indeterminate) in sync for pending & rejected
//     useEffect(() => {
//         if (!headerChkRef.current) return;
//         if (activeTab !== "pending" && activeTab !== "rejected") {
//             headerChkRef.current.checked = false;
//             headerChkRef.current.indeterminate = false;
//             return;
//         }
//         const visibleIds = filteredData.map((u) => getId(u)).filter(Boolean);
//         if (visibleIds.length === 0) {
//             headerChkRef.current.checked = false;
//             headerChkRef.current.indeterminate = false;
//             return;
//         }
//         const selectedCount = visibleIds.filter((pid) =>
//             selectedIds.includes(pid),
//         ).length;
//         if (selectedCount === 0) {
//             headerChkRef.current.checked = false;
//             headerChkRef.current.indeterminate = false;
//         } else if (selectedCount === visibleIds.length) {
//             headerChkRef.current.checked = true;
//             headerChkRef.current.indeterminate = false;
//         } else {
//             headerChkRef.current.checked = false;
//             headerChkRef.current.indeterminate = true;
//         }
//     }, [selectedIds, filteredData, activeTab]);

//     // ---------- search / pagination handlers ----------
//     const handleSearch = (e) => setSearchQuery(e.target.value);
//     const handlePageClick = ({ selected }) => setCurrentPage(selected);
//     const handleItemsPerPageChange = (e) => {
//         setItemsPerPage(parseInt(e.target.value, 10));
//         setCurrentPage(0);
//     };

//     // ---------- Excel download ----------
//     const handleDownloadExcel = () => {
//         if (!currentItems || currentItems.length === 0) return;

//         const selectedData = currentItems.map((user, index) => ({
//             "TITLE": user.title || "",
//             "NAME": `${user.first_name || ""} ${user.last_name || ""}`,
//             "PAN": user.pan_number || "",
//             "APPCODE": user.app_code || "",
//             "EMAIL": user.email || "",
//             "Disable Emails": "N",
//             "SECONDARY EMAIL": user.alt_email || "",
//             "IWELL CODE": user.iwell_code || "",
//             "USERNAME": user.pan_number || "",
//             "MOBILE": user.mobile || "",
//             "LANDLINE": user.landline || "",
//             "DATE OF BIRTH": user.dob ? new Date(user.dob).toISOString().split("T")[0] : "",
//             "BIRTHDAY WISH": "",
//             "ANNIVERSARY": "",
//             "DATE OF DEATH": "",
//             "FAMILY HEAD": user.family_head || "",
//             "FAMILY HEAD IWELL CODE": "",
//             "Referred By": user.referred_by || "",
//             "IWELL CODE 2": "",
//             "FAMILY HEAD IWELL CODE 2": "",
//             "ADDRESS1": user.address || "",
//             "ADDRESS2": user.address_line2 || "",
//             "ADDRESS3": "",
//             "CITY": user.city || "",
//             "STATE": user.state || "",
//             "Country": user.country || "",
//             "PIN": user.pin || "",
//             "CLIENT RATING": "",
//             "First Investment Date": "",
//             "REVIEW FREQUENCY": "",
//             "LAST REVIEW DATE": "",
//             "MODEL NAME": "",
//             "FILE NO": "",
//             "TAGS": "",
//             "UPDATE LOCK": "",
//             "EQUITY CODE1": "",
//             "EQUITY CODE2": "",
//             "DEPOSITORY": "",
//             "DP NAME": "",
//             "DP ID": "",
//             "NPS A/c No": "",
//             "ANNUAL INCOME": user.annual_income || "",
//             "PROFESSION": user.profession || "",
//             "Bill State": user.state || "",
//             "Bill GSTIN": user.gstin || "",
//             "AUM": "",
//             "Target SIP Amout": "",
//             "Target ELSS Amount": "",
//             "Target Equity Allocation (%)": "",
//             "Target Debt Allocation (%)": "",
//             "Preferred Billing mode": "",
//             "Equity MF Billing (%)": "",
//             "Debt MF Billing (%)": "",
//             "Shares Billing (%)": "",
//             "Bonds Billing (%)": "",
//             "Fixed Deposit Billing (%)": "",
//             "Other Assets Billing (%)": "",
//             "Remarks": "",
//             "BANK DETAILS": user.bank_name || "",
//             "OS ADDRESS1": "",
//             "OS ADDRESS2": "",
//             "OS ADDRESS3": "",
//             "OVERSEAS CITY": "",
//             "OVERSEAS STATE": "",
//             "OVERSEAS COUNTRY": "",
//             "Overseas PIN": "",
//             "OVERSEAS PHONE": "",
//             "OVERSEAS MOBILE": "",
//             "TAX STATUS": user.tax_status || "",
//             "MODE OF HOLDING": user.holding_mode || "",
//             "OCCUPATION": user.occupation || "",
//             "Joint Holder 1": "",
//             "Joint Holder 2": "",
//             "GUARDIAN NAME": user.guardian_details || "",
//             "GUARDIAN PAN": "",
//             "ATTORNEY NAME": "",
//             "ATTORNEY PAN": "",
//             "NOMINEE DETAILS": user.nominee_name || "",
//             "GROSS ANNUAL INCOME": user.gross_annual_income || "",
//             "NET WORTH": "",
//             "NET WORTH DATE": "",
//             "FOR INDIVIDUAL": "",
//             "FOR NON INDIVIDUAL": "",
//             "NATIONALITY": user.nationality || "",
//             "GENDER": user.gender || "",
//             "PLACE OF BIRTH": "",
//             "COUNTRY OF BIRTH": "",
//             "FATHER NAME": user.father_name || "",
//             "MOTHER NAME": user.mother_name || "",
//             "SPOUSE": user.spouse_name || "",
//             "KYC CHECK": user.kyc_status || "",
//             "Supplementary KYC": "",
//             "KYC Source": "",
//             "FATCA CAMS": "",
//             "FATCA KARVY": "",
//             "CKYC": "",
//             "FATCA OTHER DETAILS": "",
//             "SOURCE": "",
//             "CREATED AT": new Date(user.created_at).toLocaleDateString(),
//             "Invite Sent Date": "",
//             "Last Login Date": "",
//             "LEVEL NAME TO BE UPDATED": "",
//             "CODE TO BE UPDATED": "",
//             "LIQUILOAN NO": "",
//             "RELATIONSHIP  MANAGER": user.relationship_manager || "",
//             "RELATIONSHIP  MANAGER CODE": user.relationship_manager_code || "",
//             "SUB  BROKER": user.sub_broker || "",
//             "SUB  BROKER CODE": user.sub_broker_code || "",
//             "FAMILY HEAD USERNAME": user.family_head_username || "",
//         }));

//         const worksheet = XLSX.utils.json_to_sheet(selectedData);
//         const workbook = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(workbook, worksheet, "Client Details");
//         const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
//         const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
//         saveAs(blob, "Client Details.xlsx");
//     };

//     // ---------- SweetAlert preview helper ----------
//     const buildPreviewHtml = () => {
//         const selectedUsers = filteredData.filter((u) =>
//             selectedIds.includes(getId(u)),
//         );
//         if (selectedUsers.length === 0) {
//             return `<div style="color:#6b7280">No users selected.</div>`;
//         }
//         const items = selectedUsers.slice(0, 12).map((u) => {
//             const name =
//                 `${u.first_name || ""} ${u.last_name || ""}`.trim() || getId(u);
//             return `<div style="padding:6px 0;border-bottom:1px dashed rgba(0,0,0,0.06)">${name} <small style="color:#6b7280;margin-left:8px">(${getId(
//                 u,
//             )})</small></div>`;
//         });
//         return `<div style="text-align:left">${items.join("")}${selectedUsers.length > 12
//             ? `<div style="padding:6px 0;color:#6b7280">+ ${selectedUsers.length - 12
//             } more...</div>`
//             : ""
//             }</div>`;
//     };

//     // Called when user clicks Bulk Action button (works for both pending & rejected)
//     const handleBulkClick = () => {
//         const count = selectedIds.length;
//         if (!count) {
//             Swal.fire("No selection", "Please select at least one user.", "info");
//             return;
//         }

//         // Different copy for pending vs rejected
//         if (activeTab === "pending") {
//             Swal.fire({
//                 title: `Approve or Reject ${count} user(s)?`,
//                 html:
//                     `<p style="font-size:1rem;color:#000;line-height:1.6">You can approve (assign UCC) or reject the selected users. Choose an action below.</p>` +
//                     `<div style="margin-top:10px;max-height:160px;overflow:auto;padding:8px;border-radius:8px;border:1px solid #eef6f5;background:#fff;text-align:left">${buildPreviewHtml()}</div>`,
//                 showCloseButton: true,
//                 showDenyButton: true,
//                 showCancelButton: false,
//                 confirmButtonText: "Approve",
//                 denyButtonText: "Reject",
//                 focusConfirm: false,
//                 customClass: {
//                     popup: "swal2-border-radius",
//                 },
//             }).then((result) => {
//                 if (result.isConfirmed) {
//                     bulkApprove();
//                 } else if (result.isDenied) {
//                     bulkReject();
//                 }
//             });
//             return;
//         }

//         if (activeTab === "rejected") {
//             Swal.fire({
//                 title: `Approve ${count} rejected user(s)?`,
//                 html:
//                     `<p style="font-size:1rem;color:#000;line-height:1.6">Do you want to approve the selected rejected users?</p>` +
//                     `<div style="margin-top:10px;max-height:160px;overflow:auto;padding:8px;border-radius:8px;border:1px solid #eef6f5;background:#fff;text-align:left">${buildPreviewHtml()}</div>`,
//                 showCloseButton: true,
//                 showCancelButton: true,
//                 confirmButtonText: "Approve",
//                 cancelButtonText: "Cancel",
//                 focusConfirm: false,
//                 customClass: {
//                     popup: "swal2-border-radius",
//                 },
//             }).then((result) => {
//                 if (result.isConfirmed) {
//                     bulkApprove();
//                 }
//             });
//             return;
//         }

//     };

//     // Approve selected (calls backend)
//     const bulkApprove = async () => {
//         if (!selectedIds || selectedIds.length === 0) {
//             Swal.fire("No selection", "Please select at least one user.", "info");
//             return;
//         }

//         Swal.fire({
//             title: "Approving...",
//             html: "Please wait while selected users are being approved.",
//             didOpen: () => {
//                 Swal.showLoading();
//             },
//             allowOutsideClick: false,
//         });

//         try {
//             const payload = { userIds: selectedIds }; // adjust if backend expects different key

//             const res = await axios.put(
//                 `${process.env.REACT_APP_BACKEND_BASE_URL}/user/ucc/update`,
//                 payload,
//             );

//             Swal.close();

//             if (res.status === 200) {
//                 // refresh data
//                 await getData();

//                 // show success
//                 Swal.fire({
//                     icon: "success",
//                     title: "Approved",
//                     html: `<p>${selectedIds.length} user(s) approved successfully.</p>`,
//                 });

//                 setSelectedIds([]);
//             } else {
//                 Swal.fire(
//                     "Error",
//                     res.data?.message || "Failed to approve users.",
//                     "error",
//                 );
//             }
//         } catch (err) {
//             console.error("Bulk approve error:", err);
//             Swal.close();
//             Swal.fire("Error", "Failed to approve selected users.", "error");
//         }
//     };

//     // Reject selected (calls backend)
//     const bulkReject = async () => {
//         if (!selectedIds || selectedIds.length === 0) {
//             Swal.fire("No selection", "Please select at least one user.", "info");
//             return;
//         }

//         // show loading modal
//         Swal.fire({
//             title: "Rejecting...",
//             html: "Please wait while selected users are being rejected.",
//             didOpen: () => {
//                 Swal.showLoading();
//             },
//             allowOutsideClick: false,
//             showConfirmButton: false,
//         });

//         try {
//             const payload = { userIds: selectedIds }; // adjust if backend expects different key

//             // NOTE: change endpoint if your backend uses a different URL for reject
//             const res = await axios.put(
//                 `${process.env.REACT_APP_BACKEND_BASE_URL}/user/ucc/reject`,
//                 payload,
//             );

//             // Close loading
//             Swal.close();

//             const statusOk = res.status === 200 || res.status === 204;
//             const body = res.data || {};

//             if (
//                 statusOk &&
//                 (body.success === true ||
//                     body.updatedUsers ||
//                     body.message ||
//                     res.status === 204)
//             ) {
//                 if (Array.isArray(body.updatedUsers) && body.updatedUsers.length > 0) {
//                     setData((prev) => {
//                         const byId = new Map(body.updatedUsers.map((u) => [getId(u), u]));
//                         return prev.map((p) =>
//                             byId.has(getId(p)) ? { ...p, ...byId.get(getId(p)) } : p,
//                         );
//                     });
//                 } else {
//                     await getData();
//                 }

//                 setSelectedIds([]);
//                 const successMsg =
//                     body.message ||
//                     `${selectedIds.length} user(s) rejected successfully.`;
//                 Swal.fire({ icon: "success", title: "Rejected", text: successMsg });
//             } else {
//                 const errMsg = body.message || body.error || "Failed to reject users.";
//                 Swal.fire("Error", errMsg, "error");
//             }
//         } catch (err) {
//             Swal.close();
//             const serverMessage =
//                 err?.response?.data?.message ||
//                 err?.response?.data?.error ||
//                 err?.response?.data ||
//                 err?.message ||
//                 "Failed to reject selected users.";
//             console.error("Bulk reject error:", err);
//             Swal.fire("Error", serverMessage, "error");
//         }
//     };

//     // Delete selected permanently (for rejected tab)
//     // const bulkDelete = async () => {
//     //     if (!selectedIds || selectedIds.length === 0) {
//     //         Swal.fire("No selection", "Please select at least one user.", "info");
//     //         return;
//     //     }

//     //     Swal.fire({
//     //         title: "Deleting...",
//     //         html: "Please wait while selected users are being deleted permanently.",
//     //         didOpen: () => {
//     //             Swal.showLoading();
//     //         },
//     //         allowOutsideClick: false,
//     //         showConfirmButton: false,
//     //     });

//     //     try {
//     //         // Adjust endpoint as per your backend. Using POST /user/delete as a common pattern.
//     //         const payload = { userIds: selectedIds };
//     //         const res = await axios.post(
//     //             `${process.env.REACT_APP_BACKEND_BASE_URL}/user/delete`,
//     //             payload,
//     //         );

//     //         Swal.close();

//     //         const statusOk = res.status === 200 || res.status === 204;
//     //         const body = res.data || {};

//     //         if (statusOk) {
//     //             // refresh or apply returned updates
//     //             if (Array.isArray(body.deletedIds)) {
//     //                 setData((prev) =>
//     //                     prev.filter((p) => !body.deletedIds.includes(getId(p))),
//     //                 );
//     //             } else {
//     //                 await getData();
//     //             }

//     //             setSelectedIds([]);
//     //             Swal.fire({
//     //                 icon: "success",
//     //                 title: "Deleted",
//     //                 text: body.message || `${selectedIds.length} user(s) deleted.`,
//     //             });
//     //         } else {
//     //             Swal.fire("Error", body.message || "Failed to delete users.", "error");
//     //         }
//     //     } catch (err) {
//     //         Swal.close();
//     //         const serverMessage =
//     //             err?.response?.data?.message ||
//     //             err?.response?.data?.error ||
//     //             err?.response?.data ||
//     //             err?.message ||
//     //             "Failed to delete selected users.";
//     //         console.error("Bulk delete error:", err);
//     //         Swal.fire("Error", serverMessage, "error");
//     //     }
//     // };

//     // ---------- counts for tabs ----------
//     const totalAll = data.length;
//     const totalApprove = data.filter((u) => matchesStatus(u, "approve")).length;
//     const totalPending = data.filter((u) => matchesStatus(u, "pending")).length;
//     const totalRejected = data.filter((u) => matchesStatus(u, "rejected")).length;

//     // ---------- render ----------
//     return (
//         <>
//             <style>{`
// .table td { white-space: nowrap; vertical-align: middle; color: #0D233E; font-size: 14px; font-weight: 400; padding: 5px; }
// .tab-row { display:flex; gap:12px; margin-bottom:0; flex-wrap:wrap; }
// .tab { padding:12px 14px; border-radius:8px; cursor:pointer; background:#fff; border:1px solid #e6eef0; font-weight:700; color:#19bcb8; transition: all 0.2s ease; }
// .tab:hover { background:#f8fafc; }
// .tab.active { background: linear-gradient(90deg,#0bc1ab, #06a89d); color:#fff; border-color: transparent; box-shadow: 0 6px 18px rgba(11,183,165,0.08); }
// .tab .count { margin-left:8px; font-weight:600; opacity:0.9; background: rgba(255,255,255,0.15); padding:2px 8px; border-radius:12px; font-size:.85rem; }
// .chk-box { width:18px; height:18px; cursor: pointer; }
// .status-btn { padding:6px 10px; border-radius:6px; font-weight:700; border: none; cursor: default; font-size: 12px; }
// .status-approve { background: #10B981; color: #fff; }
// .status-pending { background: #F59E0B; color: #fff; }
// .status-rejected { background: #EF4444; color: #fff; }
// li.page-link.active { background-color: #19bcb8; border: #19bcb8; }
// .pagination > .active > a { background-color: #19bcb8; border-color: #ffffff; color: #ffffff; }

// .swal2-border-radius {
//   border-radius: 12px !important;
// }

// `}</style>

//             <div className="main-content">
//                 <div className="page-wrapper page-settings">
//                     <div className="content">
//                         {/* Breadcrumb and Header Section with Card Shadow */}
//                         <div
//                             className="mb-4"
//                             style={{
//                                 background: "#ffffff",
//                                 borderRadius: "8px",
//                                 boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
//                                 padding: "20px",
//                             }}
//                         >
//                             <div className="content-page-header content-page-headersplit">
//                                 <h5>Users</h5>
//                             </div>
//                             <nav
//                                 aria-label="breadcrumb"
//                                 style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}
//                             >
//                                 <ol className="breadcrumb">
//                                     <li className="breadcrumb-item">
//                                         <Link to="/dashboard">Dashboard</Link> /
//                                     </li>
//                                     <li className="breadcrumb-item active" aria-current="page">
//                                         Users
//                                     </li>
//                                 </ol>
//                             </nav>



//                         </div>

//                         {/* Filters and Tabs Section with Card Shadow */}
//                         <div
//                             className="mb-4"
//                             style={{
//                                 background: "#ffffff",
//                                 borderRadius: "8px",
//                                 boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
//                                 padding: "20px",
//                             }}
//                         >
//                             <div className="d-flex justify-content-between align-items-center flex-wrap"> {/* Filters */}
//                                 <div className="row g-2 flex-grow-1">
//                                     <div className="col-12 col-md-4">
//                                         <div className="form-group">
//                                             <input
//                                                 id="search"
//                                                 className="form-control"
//                                                 type="text"
//                                                 placeholder="Search by name or email..."
//                                                 aria-label="Search Input"
//                                                 value={searchQuery}
//                                                 onChange={handleSearch}
//                                             />
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="list-btn">
//                                     <ul
//                                         style={{
//                                             display: "flex",
//                                             gap: 8,
//                                             alignItems: "center",
//                                             margin: 0,
//                                             padding: 0,
//                                             listStyle: "none",
//                                         }}
//                                     >
//                                         {(activeTab === "pending" || activeTab === "rejected") && (
//                                             <li>
//                                                 <button
//                                                     className="btn btn-primary me-2"
//                                                     disabled={selectedIds.length === 0}
//                                                     onClick={handleBulkClick}
//                                                     title={
//                                                         activeTab === "pending"
//                                                             ? "Approve/Reject selected pending users"
//                                                             : "Approve/Delete selected rejected users"
//                                                     }
//                                                 >
//                                                     Bulk Action
//                                                 </button>
//                                             </li>
//                                         )}
//                                         <li>
//                                             <button
//                                                 onClick={handleDownloadExcel}
//                                                 className="btn btn-cancel"
//                                             >
//                                                 <i className="fas fa-download me-2"></i>
//                                                 Download Excel
//                                             </button>
//                                         </li>
//                                     </ul>
//                                 </div>
//                             </div>

//                             <div className="tab-row" aria-hidden>
//                                 <div
//                                     role="button"
//                                     className={`tab ${activeTab === "all" ? "active" : ""}`}
//                                     onClick={() => {
//                                         setActiveTab("all");
//                                         setCurrentPage(0);
//                                     }}
//                                 >
//                                     All <span className="count">{totalAll}</span>
//                                 </div>
//                                 <div
//                                     role="button"
//                                     className={`tab ${activeTab === "approve" ? "active" : ""}`}
//                                     onClick={() => {
//                                         setActiveTab("approve");
//                                         setCurrentPage(0);
//                                     }}
//                                 >
//                                     Approved <span className="count">{totalApprove}</span>
//                                 </div>
//                                 <div
//                                     role="button"
//                                     className={`tab ${activeTab === "rejected" ? "active" : ""}`}
//                                     onClick={() => {
//                                         setActiveTab("rejected");
//                                         setCurrentPage(0);
//                                     }}
//                                 >
//                                     Rejected <span className="count">{totalRejected}</span>
//                                 </div>
//                                 <div
//                                     role="button"
//                                     className={`tab ${activeTab === "pending" ? "active" : ""}`}
//                                     onClick={() => {
//                                         setActiveTab("pending");
//                                         setCurrentPage(0);
//                                     }}
//                                 >
//                                     Pending <span className="count">{totalPending}</span>
//                                 </div>
//                             </div>
//                         </div>

//                         {/* Table Section with Card Shadow */}
//                         <div
//                             className="mb-4"
//                             style={{
//                                 background: "#ffffff",
//                                 borderRadius: "8px",
//                                 boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
//                                 padding: "20px",
//                             }}
//                         >
//                             <div className="row">
//                                 <div className="col-12">
//                                     <div className="table-responsive">
//                                         <table className="table datatable">
//                                             <thead>
//                                                 <tr>
//                                                     {(activeTab === "pending" ||
//                                                         activeTab === "rejected") && (
//                                                             <th style={{ width: 48, textAlign: "center" }}>
//                                                                 <input
//                                                                     ref={headerChkRef}
//                                                                     type="checkbox"
//                                                                     className="chk-box"
//                                                                     onChange={toggleSelectAll}
//                                                                     aria-label={`Select all ${activeTab}`}
//                                                                 />
//                                                             </th>
//                                                         )}
//                                                     <th>Index</th>
//                                                     <th>Photo</th>
//                                                     <th>First Name</th>
//                                                     <th>Last Name</th>
//                                                     <th>Email</th>
//                                                     <th>Phone</th>
//                                                     {activeTab === "all" && <th>Status</th>}
//                                                     <th>UCC</th>
//                                                     <th>Actions</th>
//                                                 </tr>
//                                             </thead>
//                                             <tbody>
//                                                 {currentItems.length === 0 ? (
//                                                     <tr>
//                                                         <td
//                                                             colSpan={
//                                                                 activeTab === "pending" ||
//                                                                     activeTab === "rejected"
//                                                                     ? 9
//                                                                     : 8
//                                                             }
//                                                         >
//                                                             No data available
//                                                         </td>
//                                                     </tr>
//                                                 ) : (
//                                                     currentItems.map((dataa, idx) => {
//                                                         const uid = getId(dataa);
//                                                         const isSelected = uid
//                                                             ? selectedIds.includes(uid)
//                                                             : false;

//                                                         const uccRaw = dataa?.ucc ?? dataa?.UCC ?? null;
//                                                         const uccEmpty =
//                                                             uccRaw === null ||
//                                                             uccRaw === undefined ||
//                                                             (typeof uccRaw === "string" &&
//                                                                 uccRaw.trim() === "");

//                                                         const rejected = isRejectedUser(dataa);

//                                                         let statusLabel = "Pending";
//                                                         if (rejected) statusLabel = "Rejected";
//                                                         else if (!uccEmpty) statusLabel = "Approved";

//                                                         return (
//                                                             <tr key={uid ?? idx}>
//                                                                 {(activeTab === "pending" ||
//                                                                     activeTab === "rejected") && (
//                                                                         <td style={{ width: 48, textAlign: "center" }}>
//                                                                             <input
//                                                                                 type="checkbox"
//                                                                                 className="chk-box"
//                                                                                 checked={!!isSelected}
//                                                                                 onChange={() => toggleRow(uid)}
//                                                                                 aria-label={`Select user ${uid}`}
//                                                                             />
//                                                                         </td>
//                                                                     )}
//                                                                 <td>{indexOfFirstItem + idx + 1}</td>
//                                                                 <td>
//                                                                     {dataa?.photo ? (
//                                                                         <img
//                                                                             src={`${process.env.REACT_APP_BACKEND_BASE_URL_FILES}${dataa.photo}`}
//                                                                             alt="user"
//                                                                             style={{
//                                                                                 width: 45,
//                                                                                 height: 45,
//                                                                                 borderRadius: "50%",
//                                                                                 objectFit: "cover",
//                                                                                 margin: "5px 0",
//                                                                             }}
//                                                                             onError={(e) => {
//                                                                                 e.currentTarget.style.display = "none";
//                                                                             }}
//                                                                             draggable={false}
//                                                                         />
//                                                                     ) : (
//                                                                         <div
//                                                                             style={{
//                                                                                 width: 45,
//                                                                                 height: 45,
//                                                                                 borderRadius: "50%",
//                                                                                 background: "#e6f6f5",
//                                                                                 display: "flex",
//                                                                                 alignItems: "center",
//                                                                                 justifyContent: "center",
//                                                                                 color: "#0bc1ab",
//                                                                             }}
//                                                                         >
//                                                                             <i className="fas fa-user"></i>
//                                                                         </div>
//                                                                     )}
//                                                                 </td>
//                                                                 <td>{dataa.first_name || "-"}</td>
//                                                                 <td>{dataa.last_name || "-"}</td>
//                                                                 <td>{dataa.email || "-"}</td>
//                                                                 <td>
//                                                                     {(dataa.country_code || "") +
//                                                                         " " +
//                                                                         (dataa.phone || "-")}
//                                                                 </td>
//                                                                 {activeTab === "all" && (
//                                                                     <td>
//                                                                         <span
//                                                                             className={`status-btn ${statusLabel === "Approved"
//                                                                                 ? "status-approve"
//                                                                                 : statusLabel === "Rejected"
//                                                                                     ? "status-rejected"
//                                                                                     : "status-pending"
//                                                                                 }`}
//                                                                         >
//                                                                             {statusLabel}
//                                                                         </span>
//                                                                     </td>
//                                                                 )}
//                                                                 <td>{dataa.ucc ?? dataa.UCC ?? "-"}</td>
//                                                                 <td>
//                                                                     <div className="table-actions d-flex justify-content-center gap-2">
//                                                                         <Link
//                                                                             to={`/user/ucc/create/${dataa.id}`}
//                                                                             state={{
//                                                                                 user: {
//                                                                                     id: dataa.id,
//                                                                                     first_name: dataa.first_name,
//                                                                                     last_name: dataa.last_name,
//                                                                                     email: dataa.email,
//                                                                                     phone: dataa.phone,
//                                                                                     mobile: dataa.mobile,
//                                                                                 },
//                                                                             }}
//                                                                             className="delete-table"
//                                                                             title="Create UCC"
//                                                                             style={{ color: "#19bcb8" }}
//                                                                         >
//                                                                             <i className="fas fa-user-plus"></i>
//                                                                         </Link>
//                                                                         {!uccEmpty && !rejected && (
//                                                                             <>
//                                                                                 <Link
//                                                                                     to={`/user/fatca/${uid}`}
//                                                                                     className="delete-table"
//                                                                                     title="FATCA Details"
//                                                                                     style={{ color: "#19bcb8" }}
//                                                                                 >
//                                                                                     <i className="fas fa-file-invoice"></i>
//                                                                                 </Link>
//                                                                                 <Link
//                                                                                     to={`/user/aof-upload/${uid}`}
//                                                                                     className="delete-table"
//                                                                                     title="AOF Upload"
//                                                                                     style={{ color: "#19bcb8" }}
//                                                                                 >
//                                                                                     <i className="fas fa-file-signature"></i>
//                                                                                 </Link>
//                                                                                 <Link
//                                                                                     to={`/user/cheque-upload/${uid}`}
//                                                                                     className="delete-table"
//                                                                                     title="Cheque Upload"
//                                                                                     style={{ color: "#19bcb8" }}
//                                                                                 >
//                                                                                     <i className="fas fa-money-check-alt"></i>
//                                                                                 </Link>
//                                                                                 <Link
//                                                                                     to={`/user/lumpsum/${uid}`}
//                                                                                     className="delete-table"
//                                                                                     title="Lumpsum Purchase"
//                                                                                     style={{ color: "#19bcb8" }}
//                                                                                 >
//                                                                                     <i className="fas fa-rupee-sign"></i>
//                                                                                 </Link>
//                                                                                 <Link
//                                                                                     to={`/user/lumpsum-redemption/${uid}`}
//                                                                                     className="delete-table"
//                                                                                     title="Lumpsum Redemption"
//                                                                                     style={{ color: "#19bcb8" }}
//                                                                                 >
//                                                                                     <i className="fas fa-hand-holding-usd"></i>
//                                                                                 </Link>
//                                                                                 <Link
//                                                                                     to={`/user/mandate-registration/${uid}`}
//                                                                                     className="delete-table"
//                                                                                     title="Mandate Registration"
//                                                                                     style={{ color: "#19bcb8" }}
//                                                                                 >
//                                                                                     <i className="fas fa-university"></i>
//                                                                                 </Link>
//                                                                                 <Link
//                                                                                     to={`/user/sip-registration/${uid}`}
//                                                                                     className="delete-table"
//                                                                                     title="SIP Registration"
//                                                                                     style={{ color: "#19bcb8" }}
//                                                                                 >
//                                                                                     <i className="fas fa-calendar-plus"></i>
//                                                                                 </Link>
//                                                                                 <Link
//                                                                                     to={`/user/xsip-registration/${uid}`}
//                                                                                     className="delete-table"
//                                                                                     title="XSIP/ISIP Registration"
//                                                                                     style={{ color: "#19bcb8" }}
//                                                                                 >
//                                                                                     <i className="fas fa-calendar-check"></i>
//                                                                                 </Link>
//                                                                                 <Link
//                                                                                     to={`/user/sip-list/${uid}`}
//                                                                                     className="delete-table"
//                                                                                     title="SIP List (Pause/Resume/Cancel)"
//                                                                                     style={{ color: "#19bcb8" }}
//                                                                                 >
//                                                                                     <i className="fas fa-list"></i>
//                                                                                 </Link>
//                                                                                 <Link
//                                                                                     to={`/user/switch-order/${uid}`}
//                                                                                     className="delete-table"
//                                                                                     title="Switch Order"
//                                                                                     style={{ color: "#19bcb8" }}
//                                                                                 >
//                                                                                     <i className="fas fa-exchange-alt"></i>
//                                                                                 </Link>
//                                                                                 <Link
//                                                                                     to={`/user/spread-order/${uid}`}
//                                                                                     className="delete-table"
//                                                                                     title="Spread Order (Bulk)"
//                                                                                     style={{ color: "#19bcb8" }}
//                                                                                 >
//                                                                                     <i className="fas fa-layer-group"></i>
//                                                                                 </Link>
//                                                                                 <Link
//                                                                                     to="/payment/status"
//                                                                                     state={{ clientCode: String(uccRaw || '').trim() }}
//                                                                                     className="delete-table"
//                                                                                     title="Payment Status"
//                                                                                     style={{ color: "#19bcb8" }}
//                                                                                 >
//                                                                                     <i className="fas fa-credit-card"></i>
//                                                                                 </Link>
//                                                                                 <Link
//                                                                                     to="/user/order-status"
//                                                                                     state={{ clientCode: String(uccRaw || '').trim() }}
//                                                                                     className="delete-table"
//                                                                                     title="Order Status"
//                                                                                     style={{ color: "#19bcb8" }}
//                                                                                 >
//                                                                                     <i className="fas fa-clipboard-list"></i>
//                                                                                 </Link>
//                                                                                 <Link
//                                                                                     to="/user/child-order-status"
//                                                                                     state={{ clientCode: String(uccRaw || '').trim() }}
//                                                                                     className="delete-table"
//                                                                                     title="Child Order Status"
//                                                                                     style={{ color: "#19bcb8" }}
//                                                                                 >
//                                                                                     <i className="fas fa-sitemap"></i>
//                                                                                 </Link>
//                                                                                 <Link
//                                                                                     to="/user/allotment-statement"
//                                                                                     state={{ clientCode: String(uccRaw || '').trim() }}
//                                                                                     className="delete-table"
//                                                                                     title="Allotment Statement"
//                                                                                     style={{ color: "#19bcb8" }}
//                                                                                 >
//                                                                                     <i className="fas fa-file-invoice-dollar"></i>
//                                                                                 </Link>
//                                                                                 <Link
//                                                                                     to="/user/redemption-statement"
//                                                                                     state={{ clientCode: String(uccRaw || '').trim() }}
//                                                                                     className="delete-table"
//                                                                                     title="Redemption Statement"
//                                                                                     style={{ color: "#19bcb8" }}
//                                                                                 >
//                                                                                     <i className="fas fa-receipt"></i>
//                                                                                 </Link>
//                                                                                 <Link
//                                                                                     to="/user/mandate-status"
//                                                                                     state={{ clientCode: String(uccRaw || '').trim() }}
//                                                                                     className="delete-table"
//                                                                                     title="Mandate Status"
//                                                                                     style={{ color: "#19bcb8" }}
//                                                                                 >
//                                                                                     <i className="fas fa-file-contract"></i>
//                                                                                 </Link>
//                                                                                 <Link
//                                                                                     to="/user/mandate-upload"
//                                                                                     state={{ clientCode: String(uccRaw || '').trim() }}
//                                                                                     className="delete-table"
//                                                                                     title="Mandate Upload"
//                                                                                     style={{ color: "#19bcb8" }}
//                                                                                 >
//                                                                                     <i className="fas fa-upload"></i>
//                                                                                 </Link>
//                                                                             </>
//                                                                         )}
//                                                                         <Link
//                                                                             to={`/clientview/${dataa.id}`}
//                                                                             className="delete-table"
//                                                                             title="View User"
//                                                                         >
//                                                                             <i className="fas fa-eye"></i>
//                                                                         </Link>
//                                                                     </div>
//                                                                 </td>
//                                                             </tr>
//                                                         );
//                                                     })
//                                                 )}
//                                             </tbody>
//                                         </table>
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* Pagination */}
//                             {pageCount > 1 && (
//                                 <nav
//                                     className="mt-4 pagination justify-content-end gap-2"
//                                     aria-label="Table pagination"
//                                 >
//                                     <select
//                                         className="form-select"
//                                         style={{ width: "70px", padding: "0 13px" }}
//                                         value={itemsPerPage}
//                                         onChange={handleItemsPerPageChange}
//                                     >
//                                         <option value="10">10</option>
//                                         <option value="20">20</option>
//                                         <option value="30">30</option>
//                                         <option value="40">40</option>
//                                         <option value="50">50</option>
//                                         <option value="100">100</option>
//                                         <option value="150">150</option>
//                                     </select>
//                                     <ReactPaginate
//                                         breakLabel="..."
//                                         nextLabel="Next"
//                                         onPageChange={handlePageClick}
//                                         forcePage={currentPage}
//                                         pageCount={pageCount}
//                                         previousLabel="Previous"
//                                         renderOnZeroPageCount={null}
//                                         containerClassName="pagination"
//                                         pageClassName="page-item"
//                                         pageLinkClassName="page-link"
//                                         previousClassName="page-item"
//                                         previousLinkClassName="page-link"
//                                         nextClassName="page-item"
//                                         nextLinkClassName="page-link"
//                                         breakClassName="page-item"
//                                         breakLinkClassName="page-link"
//                                         activeClassName="active"
//                                     />
//                                 </nav>
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default UsersList;





















import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import ReactPaginate from "react-paginate";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Swal from "sweetalert2";

// Actions dropdown - prevent close when clicking inside
const ActionsDropdown = ({ user, uccRaw, uccEmpty, rejected }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const uid = user?.id ?? user?._id ?? user?.user_id ?? null;
    const ucc = String(uccRaw || "").trim();

    const actionLink = (to, icon, label, state) => (
        <Link
            to={to}
            state={state}
            className="dropdown-item d-flex align-items-center py-2"
            onClick={() => setOpen(false)}
        >
            <i className={`fas ${icon} me-2`} style={{ width: 18, color: "#19bcb8" }} />
            <span>{label}</span>
        </Link>
    );

    return (
        <div className="dropdown position-relative" ref={ref}>
            <button
                type="button"
                className="btn btn-sm btn-outline-secondary dropdown-toggle"
                onClick={() => setOpen(!open)}
                aria-expanded={open}
                aria-haspopup="true"
            >
                Actions
            </button>
            {open && (
                <div
                    className="dropdown-menu show shadow-sm border"
                    style={{ minWidth: 220, maxHeight: 400, overflowY: "auto", zIndex: 1050, marginLeft: "-110px" }}
                >
                    <div className="dropdown-header small text-muted">Profile</div>
                    {actionLink(`/clientview/${user.id}`, "fa-eye", "View Profile")}
                    {actionLink(`/user/ucc/create/${user.id}`, "fa-user-plus", "Create UCC", {
                        user: { id: user.id, first_name: user.first_name, last_name: user.last_name, email: user.email, phone: user.phone, mobile: user.mobile },
                    })}

                    {!uccEmpty && !rejected && (
                        <>
                            <div className="dropdown-divider" />
                            <div className="dropdown-header small text-muted">KYC & Documents</div>
                            {actionLink(`/user/fatca/${uid}`, "fa-file-invoice", "FATCA")}
                            {actionLink(`/user/aof-upload/${uid}`, "fa-file-signature", "AOF Upload")}
                            {actionLink(`/user/cheque-upload/${uid}`, "fa-money-check-alt", "Cheque Upload")}

                            <div className="dropdown-divider" />
                            <div className="dropdown-header small text-muted">Orders</div>
                            {actionLink(`/user/lumpsum/${uid}`, "fa-rupee-sign", "Lumpsum Purchase")}
                            {actionLink(`/user/lumpsum-redemption/${uid}`, "fa-hand-holding-usd", "Lumpsum Redemption")}
                            {actionLink(`/user/switch-order/${uid}`, "fa-exchange-alt", "Switch Order")}
                            {actionLink(`/user/spread-order/${uid}`, "fa-layer-group", "Spread Order")}
                            {actionLink(`/user/mandate-registration/${uid}`, "fa-university", "Mandate Registration")}
                            {actionLink(`/user/sip-registration/${uid}`, "fa-calendar-plus", "SIP Registration")}
                            {actionLink(`/user/xsip-registration/${uid}`, "fa-calendar-check", "XSIP/ISIP")}
                            {actionLink(`/user/sip-list/${uid}`, "fa-list", "SIP List")}

                            <div className="dropdown-divider" />
                            <div className="dropdown-header small text-muted">Reports & Status</div>
                            {actionLink("/payment/status", "fa-credit-card", "Payment Status", { clientCode: ucc })}
                            {actionLink("/user/order-status", "fa-clipboard-list", "Order Status", { clientCode: ucc })}
                            {actionLink("/user/child-order-status", "fa-sitemap", "Child Order Status", { clientCode: ucc })}
                            {actionLink("/user/allotment-statement", "fa-file-invoice-dollar", "Allotment Statement", { clientCode: ucc })}
                            {actionLink("/user/redemption-statement", "fa-receipt", "Redemption Statement", { clientCode: ucc })}
                            {actionLink("/user/mandate-status", "fa-file-contract", "Mandate Status", { clientCode: ucc })}
                        </>
                    )}
                </div>
            )}
        </div>
    );
};

const UsersList = () => {
    // ---------- state & refs (always declared unconditionally) ----------
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    const [activeTab, setActiveTab] = useState("all"); // 'all' | 'approve' | 'pending' | 'rejected'
    const [selectedIds, setSelectedIds] = useState([]); // selected pending/rejected ids
    const [loading, setLoading] = useState(true);
    const [networkError, setNetworkError] = useState(null); // Backend unreachable
    const headerChkRef = useRef(null);

    // ---------- helper: get unique id (backend might use id/_id/user_id) ----------
    const getId = (u) => u?.id ?? u?._id ?? u?.user_id ?? null;

    // ---------- robust rejected detection ----------
    const isRejectedUser = (user) => {
        if (!user) return false;

        if (user?.rejected === true) return true;
        if (user?.is_rejected === true) return true;

        const maybe = (v) => v === 1 || v === "1" || v === "yes" || v === "true";
        if (maybe(user?.rejected) || maybe(user?.is_rejected)) return true;

        const s = (user?.status ?? "").toString().toLowerCase();
        if (s.includes("reject")) return true;
        if (s === "rejected") return true;

        const other = (user?.approval_status ?? user?.approval ?? "")
            .toString()
            .toLowerCase();
        if (other.includes("reject") || other === "rejected") return true;

        return false;
    };

    // ---------- fetch data ----------
    const getData = async () => {
        setLoading(true);
        setNetworkError(null);
        try {
            const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL || "http://localhost:8000/api";
            const res = await axios.get(`${baseUrl}/user/all`);
            if (res.status === 200) {
                setData(res.data.data || []);
            } else {
                setData([]);
            }
        } catch (err) {
            console.error("UserList getData error:", err);
            setData([]);
            const isNetwork =
                err.code === "ERR_NETWORK" ||
                err.message === "Network Error" ||
                (err.message && String(err.message).toLowerCase().includes("connection refused"));
            setNetworkError(
                isNetwork
                    ? "Backend server is not running. Start it with: cd back && npm start"
                    : err.response?.data?.message || err.response?.data?.error || err.message || "Failed to load users",
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getData();
    }, []);

    // ---------- status match helper ----------
    const matchesStatus = (user, tab) => {
        const uccRaw = user?.ucc ?? user?.UCC ?? null;

        const uccEmpty =
            uccRaw === null ||
            uccRaw === undefined ||
            (typeof uccRaw === "string" && uccRaw.trim() === "");

        const isRejected = uccRaw === "Reject";
        const isApproved = !uccEmpty && uccRaw !== "Reject";

        if (tab === "all") return true;
        if (tab === "approve") return isApproved;
        if (tab === "pending") return uccEmpty;
        if (tab === "rejected") return isRejected;
        return true;
    };

    // ---------- filter by tab + search (runs whenever data/search/tab changes) ----------
    useEffect(() => {
        const q = (searchQuery || "").trim().toLowerCase();
        const result = (data || []).filter((item) => {
            if (!matchesStatus(item, activeTab)) return false;
            if (!q) return true;
            const first = (item.first_name || "").toString().toLowerCase();
            const last = (item.last_name || "").toString().toLowerCase();
            const email = (item.email || "").toString().toLowerCase();
            return first.includes(q) || last.includes(q) || email.includes(q);
        });

        setFilteredData(result);
        setCurrentPage(0);

        // if switching away from pending or rejected, clear selectedIds to avoid stale selections
        if (activeTab !== "pending" && activeTab !== "rejected") {
            setSelectedIds([]);
        }
    }, [data, searchQuery, activeTab]);

    // ---------- derive pagination values ----------
    const indexOfLastItem = (currentPage + 1) * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const pageCount = Math.ceil((filteredData.length || 0) / itemsPerPage);

    // ---------- selection helpers ----------
    const toggleRow = (id) => {
        if (!id) return;
        setSelectedIds((prev) => {
            const set = new Set(prev);
            if (set.has(id)) set.delete(id);
            else set.add(id);
            return Array.from(set);
        });
    };

    // Toggle select all for current filteredData (used for both pending & rejected tabs)
    const toggleSelectAll = () => {
        const idsOnPage = filteredData.map((u) => getId(u)).filter(Boolean);
        if (idsOnPage.length === 0) {
            setSelectedIds([]);
            return;
        }
        const allSelected = idsOnPage.every((pid) => selectedIds.includes(pid));
        if (allSelected) {
            // unselect all that are currently visible
            setSelectedIds((prev) => prev.filter((id) => !idsOnPage.includes(id)));
        } else {
            // add all visible ids
            setSelectedIds((prev) => {
                const set = new Set(prev);
                idsOnPage.forEach((p) => set.add(p));
                return Array.from(set);
            });
        }
    };

    // Keep header checkbox state (checked / indeterminate) in sync for pending & rejected
    useEffect(() => {
        if (!headerChkRef.current) return;
        if (activeTab !== "pending" && activeTab !== "rejected") {
            headerChkRef.current.checked = false;
            headerChkRef.current.indeterminate = false;
            return;
        }
        const visibleIds = filteredData.map((u) => getId(u)).filter(Boolean);
        if (visibleIds.length === 0) {
            headerChkRef.current.checked = false;
            headerChkRef.current.indeterminate = false;
            return;
        }
        const selectedCount = visibleIds.filter((pid) =>
            selectedIds.includes(pid),
        ).length;
        if (selectedCount === 0) {
            headerChkRef.current.checked = false;
            headerChkRef.current.indeterminate = false;
        } else if (selectedCount === visibleIds.length) {
            headerChkRef.current.checked = true;
            headerChkRef.current.indeterminate = false;
        } else {
            headerChkRef.current.checked = false;
            headerChkRef.current.indeterminate = true;
        }
    }, [selectedIds, filteredData, activeTab]);

    // ---------- search / pagination handlers ----------
    const handleSearch = (e) => setSearchQuery(e.target.value);
    const handlePageClick = ({ selected }) => setCurrentPage(selected);
    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(parseInt(e.target.value, 10));
        setCurrentPage(0);
    };

    // ---------- Excel download ----------
    const handleDownloadExcel = () => {
        if (!currentItems || currentItems.length === 0) return;

        const selectedData = currentItems.map((user, index) => ({
            "TITLE": user.title || "",
            "NAME": `${user.first_name || ""} ${user.last_name || ""}`,
            "PAN": user.pan_number || "",
            "APPCODE": user.app_code || "",
            "EMAIL": user.email || "",
            "Disable Emails": "N",
            "SECONDARY EMAIL": user.alt_email || "",
            "IWELL CODE": user.iwell_code || "",
            "USERNAME": user.pan_number || "",
            "MOBILE": user.mobile || "",
            "LANDLINE": user.landline || "",
            "DATE OF BIRTH": user.dob ? new Date(user.dob).toISOString().split("T")[0] : "",
            "BIRTHDAY WISH": "",
            "ANNIVERSARY": "",
            "DATE OF DEATH": "",
            "FAMILY HEAD": user.family_head || "",
            "FAMILY HEAD IWELL CODE": "",
            "Referred By": user.referred_by || "",
            "IWELL CODE 2": "",
            "FAMILY HEAD IWELL CODE 2": "",
            "ADDRESS1": user.address || "",
            "ADDRESS2": user.address_line2 || "",
            "ADDRESS3": "",
            "CITY": user.city || "",
            "STATE": user.state || "",
            "Country": user.country || "",
            "PIN": user.pin || "",
            "CLIENT RATING": "",
            "First Investment Date": "",
            "REVIEW FREQUENCY": "",
            "LAST REVIEW DATE": "",
            "MODEL NAME": "",
            "FILE NO": "",
            "TAGS": "",
            "UPDATE LOCK": "",
            "EQUITY CODE1": "",
            "EQUITY CODE2": "",
            "DEPOSITORY": "",
            "DP NAME": "",
            "DP ID": "",
            "NPS A/c No": "",
            "ANNUAL INCOME": user.annual_income || "",
            "PROFESSION": user.profession || "",
            "Bill State": user.state || "",
            "Bill GSTIN": user.gstin || "",
            "AUM": "",
            "Target SIP Amout": "",
            "Target ELSS Amount": "",
            "Target Equity Allocation (%)": "",
            "Target Debt Allocation (%)": "",
            "Preferred Billing mode": "",
            "Equity MF Billing (%)": "",
            "Debt MF Billing (%)": "",
            "Shares Billing (%)": "",
            "Bonds Billing (%)": "",
            "Fixed Deposit Billing (%)": "",
            "Other Assets Billing (%)": "",
            "Remarks": "",
            "BANK DETAILS": user.bank_name || "",
            "OS ADDRESS1": "",
            "OS ADDRESS2": "",
            "OS ADDRESS3": "",
            "OVERSEAS CITY": "",
            "OVERSEAS STATE": "",
            "OVERSEAS COUNTRY": "",
            "Overseas PIN": "",
            "OVERSEAS PHONE": "",
            "OVERSEAS MOBILE": "",
            "TAX STATUS": user.tax_status || "",
            "MODE OF HOLDING": user.holding_mode || "",
            "OCCUPATION": user.occupation || "",
            "Joint Holder 1": "",
            "Joint Holder 2": "",
            "GUARDIAN NAME": user.guardian_details || "",
            "GUARDIAN PAN": "",
            "ATTORNEY NAME": "",
            "ATTORNEY PAN": "",
            "NOMINEE DETAILS": user.nominee_name || "",
            "GROSS ANNUAL INCOME": user.gross_annual_income || "",
            "NET WORTH": "",
            "NET WORTH DATE": "",
            "FOR INDIVIDUAL": "",
            "FOR NON INDIVIDUAL": "",
            "NATIONALITY": user.nationality || "",
            "GENDER": user.gender || "",
            "PLACE OF BIRTH": "",
            "COUNTRY OF BIRTH": "",
            "FATHER NAME": user.father_name || "",
            "MOTHER NAME": user.mother_name || "",
            "SPOUSE": user.spouse_name || "",
            "KYC CHECK": user.kyc_status || "",
            "Supplementary KYC": "",
            "KYC Source": "",
            "FATCA CAMS": "",
            "FATCA KARVY": "",
            "CKYC": "",
            "FATCA OTHER DETAILS": "",
            "SOURCE": "",
            "CREATED AT": new Date(user.created_at).toLocaleDateString(),
            "Invite Sent Date": "",
            "Last Login Date": "",
            "LEVEL NAME TO BE UPDATED": "",
            "CODE TO BE UPDATED": "",
            "LIQUILOAN NO": "",
            "RELATIONSHIP  MANAGER": user.relationship_manager || "",
            "RELATIONSHIP  MANAGER CODE": user.relationship_manager_code || "",
            "SUB  BROKER": user.sub_broker || "",
            "SUB  BROKER CODE": user.sub_broker_code || "",
            "FAMILY HEAD USERNAME": user.family_head_username || "",
        }));

        const worksheet = XLSX.utils.json_to_sheet(selectedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Client Details");
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(blob, "Client Details.xlsx");
    };

    // ---------- SweetAlert preview helper ----------
    const buildPreviewHtml = () => {
        const selectedUsers = filteredData.filter((u) =>
            selectedIds.includes(getId(u)),
        );
        if (selectedUsers.length === 0) {
            return `<div style="color:#6b7280">No users selected.</div>`;
        }
        const items = selectedUsers.slice(0, 12).map((u) => {
            const name =
                `${u.first_name || ""} ${u.last_name || ""}`.trim() || getId(u);
            return `<div style="padding:6px 0;border-bottom:1px dashed rgba(0,0,0,0.06)">${name} <small style="color:#6b7280;margin-left:8px">(${getId(
                u,
            )})</small></div>`;
        });
        return `<div style="text-align:left">${items.join("")}${selectedUsers.length > 12
            ? `<div style="padding:6px 0;color:#6b7280">+ ${selectedUsers.length - 12
            } more...</div>`
            : ""
            }</div>`;
    };

    // Called when user clicks Bulk Action button (works for both pending & rejected)
    const handleBulkClick = () => {
        const count = selectedIds.length;
        if (!count) {
            Swal.fire("No selection", "Please select at least one user.", "info");
            return;
        }

        // Different copy for pending vs rejected
        if (activeTab === "pending") {
            Swal.fire({
                title: `Approve or Reject ${count} user(s)?`,
                html:
                    `<p style="font-size:1rem;color:#000;line-height:1.6">You can approve (assign UCC) or reject the selected users. Choose an action below.</p>` +
                    `<div style="margin-top:10px;max-height:160px;overflow:auto;padding:8px;border-radius:8px;border:1px solid #eef6f5;background:#fff;text-align:left">${buildPreviewHtml()}</div>`,
                showCloseButton: true,
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonText: "Approve",
                denyButtonText: "Reject",
                focusConfirm: false,
                customClass: {
                    popup: "swal2-border-radius",
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    bulkApprove();
                } else if (result.isDenied) {
                    bulkReject();
                }
            });
            return;
        }

        if (activeTab === "rejected") {
            Swal.fire({
                title: `Approve ${count} rejected user(s)?`,
                html:
                    `<p style="font-size:1rem;color:#000;line-height:1.6">Do you want to approve the selected rejected users?</p>` +
                    `<div style="margin-top:10px;max-height:160px;overflow:auto;padding:8px;border-radius:8px;border:1px solid #eef6f5;background:#fff;text-align:left">${buildPreviewHtml()}</div>`,
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: "Approve",
                cancelButtonText: "Cancel",
                focusConfirm: false,
                customClass: {
                    popup: "swal2-border-radius",
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    bulkApprove();
                }
            });
            return;
        }

    };

    // Approve selected (calls backend)
    const bulkApprove = async () => {
        if (!selectedIds || selectedIds.length === 0) {
            Swal.fire("No selection", "Please select at least one user.", "info");
            return;
        }

        Swal.fire({
            title: "Approving...",
            html: "Please wait while selected users are being approved.",
            didOpen: () => {
                Swal.showLoading();
            },
            allowOutsideClick: false,
        });

        try {
            const payload = { userIds: selectedIds }; // adjust if backend expects different key

            const res = await axios.put(
                `${process.env.REACT_APP_BACKEND_BASE_URL}/user/ucc/update`,
                payload,
            );

            Swal.close();

            if (res.status === 200) {
                // refresh data
                await getData();

                // show success
                Swal.fire({
                    icon: "success",
                    title: "Approved",
                    html: `<p>${selectedIds.length} user(s) approved successfully.</p>`,
                });

                setSelectedIds([]);
            } else {
                Swal.fire(
                    "Error",
                    res.data?.message || "Failed to approve users.",
                    "error",
                );
            }
        } catch (err) {
            console.error("Bulk approve error:", err);
            Swal.close();
            Swal.fire("Error", "Failed to approve selected users.", "error");
        }
    };

    // Reject selected (calls backend)
    const bulkReject = async () => {
        if (!selectedIds || selectedIds.length === 0) {
            Swal.fire("No selection", "Please select at least one user.", "info");
            return;
        }

        // show loading modal
        Swal.fire({
            title: "Rejecting...",
            html: "Please wait while selected users are being rejected.",
            didOpen: () => {
                Swal.showLoading();
            },
            allowOutsideClick: false,
            showConfirmButton: false,
        });

        try {
            const payload = { userIds: selectedIds }; // adjust if backend expects different key

            // NOTE: change endpoint if your backend uses a different URL for reject
            const res = await axios.put(
                `${process.env.REACT_APP_BACKEND_BASE_URL}/user/ucc/reject`,
                payload,
            );

            // Close loading
            Swal.close();

            const statusOk = res.status === 200 || res.status === 204;
            const body = res.data || {};

            if (
                statusOk &&
                (body.success === true ||
                    body.updatedUsers ||
                    body.message ||
                    res.status === 204)
            ) {
                if (Array.isArray(body.updatedUsers) && body.updatedUsers.length > 0) {
                    setData((prev) => {
                        const byId = new Map(body.updatedUsers.map((u) => [getId(u), u]));
                        return prev.map((p) =>
                            byId.has(getId(p)) ? { ...p, ...byId.get(getId(p)) } : p,
                        );
                    });
                } else {
                    await getData();
                }

                setSelectedIds([]);
                const successMsg =
                    body.message ||
                    `${selectedIds.length} user(s) rejected successfully.`;
                Swal.fire({ icon: "success", title: "Rejected", text: successMsg });
            } else {
                const errMsg = body.message || body.error || "Failed to reject users.";
                Swal.fire("Error", errMsg, "error");
            }
        } catch (err) {
            Swal.close();
            const serverMessage =
                err?.response?.data?.message ||
                err?.response?.data?.error ||
                err?.response?.data ||
                err?.message ||
                "Failed to reject selected users.";
            console.error("Bulk reject error:", err);
            Swal.fire("Error", serverMessage, "error");
        }
    };

    // Delete selected permanently (for rejected tab)
    // const bulkDelete = async () => {
    //     if (!selectedIds || selectedIds.length === 0) {
    //         Swal.fire("No selection", "Please select at least one user.", "info");
    //         return;
    //     }

    //     Swal.fire({
    //         title: "Deleting...",
    //         html: "Please wait while selected users are being deleted permanently.",
    //         didOpen: () => {
    //             Swal.showLoading();
    //         },
    //         allowOutsideClick: false,
    //         showConfirmButton: false,
    //     });

    //     try {
    //         // Adjust endpoint as per your backend. Using POST /user/delete as a common pattern.
    //         const payload = { userIds: selectedIds };
    //         const res = await axios.post(
    //             `${process.env.REACT_APP_BACKEND_BASE_URL}/user/delete`,
    //             payload,
    //         );

    //         Swal.close();

    //         const statusOk = res.status === 200 || res.status === 204;
    //         const body = res.data || {};

    //         if (statusOk) {
    //             // refresh or apply returned updates
    //             if (Array.isArray(body.deletedIds)) {
    //                 setData((prev) =>
    //                     prev.filter((p) => !body.deletedIds.includes(getId(p))),
    //                 );
    //             } else {
    //                 await getData();
    //             }

    //             setSelectedIds([]);
    //             Swal.fire({
    //                 icon: "success",
    //                 title: "Deleted",
    //                 text: body.message || `${selectedIds.length} user(s) deleted.`,
    //             });
    //         } else {
    //             Swal.fire("Error", body.message || "Failed to delete users.", "error");
    //         }
    //     } catch (err) {
    //         Swal.close();
    //         const serverMessage =
    //             err?.response?.data?.message ||
    //             err?.response?.data?.error ||
    //             err?.response?.data ||
    //             err?.message ||
    //             "Failed to delete selected users.";
    //         console.error("Bulk delete error:", err);
    //         Swal.fire("Error", serverMessage, "error");
    //     }
    // };

    // ---------- counts for tabs ----------
    const totalAll = data.length;
    const totalApprove = data.filter((u) => matchesStatus(u, "approve")).length;
    const totalPending = data.filter((u) => matchesStatus(u, "pending")).length;
    const totalRejected = data.filter((u) => matchesStatus(u, "rejected")).length;

    // ---------- render ----------
    return (
        <>
            <style>{`
.users-page .page-header { border-bottom: 1px solid #eef2f5; padding-bottom: 1rem; margin-bottom: 1.5rem; }
.users-page .page-title { font-size: 1.5rem; font-weight: 600; color: #0f172a; margin: 0; }
.users-page .search-input { border-radius: 8px; border: 1px solid #e2e8f0; padding: 0.5rem 1rem; }
.users-page .search-input:focus { border-color: #19bcb8; box-shadow: 0 0 0 3px rgba(11,111,104,0.1); }
.users-page .tab-row { display: flex; gap: 0.5rem; flex-wrap: wrap; }
.users-page .tab { padding: 0.5rem 1rem; border-radius: 8px; cursor: pointer; background: #f8fafc; border: 1px solid #e2e8f0; font-weight: 500; color: #475569; transition: all 0.2s; font-size: 0.9rem; }
.users-page .tab:hover { background: #f1f5f9; color: #19bcb8; }
.users-page .tab.active { background: #19bcb8; color: #fff; border-color: #19bcb8; }
.users-page .tab .count { margin-left: 6px; opacity: 0.9; padding: 2px 6px; border-radius: 6px; font-size: 0.8rem; background: rgba(255,255,255,0.2); }
.users-page .table-card { border-radius: 12px; box-shadow: 0 1px 3px rgba(0,0,0,0.06); border: 1px solid #eef2f5; overflow: hidden; }
.users-page .table thead th { background: #f8fafc; color: #475569; font-weight: 600; font-size: 0.8rem; text-transform: uppercase; letter-spacing: 0.03em; padding: 0.9rem 1rem; border-bottom: 1px solid #e2e8f0; }
.users-page .table tbody td { padding: 0.9rem 1rem; vertical-align: middle; font-size: 0.9rem; color: #334155; }
.users-page .table tbody tr:hover { background: #f8fafc; }
.users-page .chk-box { width: 18px; height: 18px; cursor: pointer; accent-color: #19bcb8; }
.users-page .status-badge { padding: 4px 10px; border-radius: 6px; font-weight: 600; font-size: 0.75rem; }
.users-page .status-approved { background: #d1fae5; color: #047857; }
.users-page .status-approve { background: #d1fae5; color: #047857; }
.users-page .status-pending { background: #fef3c7; color: #b45309; }
.users-page .status-rejected { background: #fee2e2; color: #b91c1c; }
.users-page .pagination .page-link { border-radius: 6px !important; margin: 0 2px; }
.users-page .pagination .page-item.active .page-link { background: #19bcb8; border-color: #19bcb8; }
.users-page .btn-download { background: #fff; border: 1px solid #e2e8f0; color: #475569; border-radius: 8px; }
.users-page .btn-download:hover { background: #f8fafc; border-color: #19bcb8; color: #19bcb8; }
.swal2-border-radius { border-radius: 12px !important; }
`}</style>

            <div className="main-content users-page">
                <div className="page-wrapper page-settings">
                    <div className="content">
                        {/* Header */}
                        <div
                            className="mb-4"
                            style={{
                                background: "#ffffff",
                                borderRadius: "8px",
                                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                                padding: "20px",
                            }}
                        >
                            <div className="content-page-header content-page-headersplit">
                                <h5>Users</h5>
                            </div>
                            <nav
                                aria-label="breadcrumb"
                                style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}
                            >
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/dashboard">Dashboard</Link> /
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Users
                                    </li>
                                </ol>
                            </nav>



                        </div>



                        {/* Filters and Tabs */}
                        <div className="card border-0 shadow-sm mb-4">
                            <div className="card-body p-4">
                                <div className="row g-3 align-items-center mb-4">
                                    <div className="col-12 col-md-4">
                                        <input
                                            id="search"
                                            className="form-control search-input"
                                            type="text"
                                            placeholder="Search by name or email..."
                                            aria-label="Search"
                                            value={searchQuery}
                                            onChange={handleSearch}
                                        />
                                    </div>
                                    <div className="col-12 col-md-8 text-md-end">
                                        {(activeTab === "pending" || activeTab === "rejected") && (
                                            <button
                                                className="btn btn-primary me-2"
                                                disabled={selectedIds.length === 0}
                                                onClick={handleBulkClick}
                                                title={activeTab === "pending" ? "Approve/Reject selected" : "Approve selected"}
                                            >
                                                <i className="fas fa-check-double me-2"></i>Bulk Action
                                            </button>
                                        )}
                                        <button onClick={handleDownloadExcel} className="btn btn-primary">
                                            <i className="fas fa-download me-2"></i>Download Excel
                                        </button>
                                    </div>
                                </div>

                                <div className="tab-row" aria-hidden>
                                    <div
                                        role="button"
                                        className={`tab ${activeTab === "all" ? "active" : ""}`}
                                        onClick={() => {
                                            setActiveTab("all");
                                            setCurrentPage(0);
                                        }}
                                    >
                                        All <span className="count">{totalAll}</span>
                                    </div>
                                    <div
                                        role="button"
                                        className={`tab ${activeTab === "approve" ? "active" : ""}`}
                                        onClick={() => {
                                            setActiveTab("approve");
                                            setCurrentPage(0);
                                        }}
                                    >
                                        Approved <span className="count">{totalApprove}</span>
                                    </div>
                                    <div
                                        role="button"
                                        className={`tab ${activeTab === "rejected" ? "active" : ""}`}
                                        onClick={() => {
                                            setActiveTab("rejected");
                                            setCurrentPage(0);
                                        }}
                                    >
                                        Rejected <span className="count">{totalRejected}</span>
                                    </div>
                                    <div
                                        role="button"
                                        className={`tab ${activeTab === "pending" ? "active" : ""}`}
                                        onClick={() => {
                                            setActiveTab("pending");
                                            setCurrentPage(0);
                                        }}
                                    >
                                        Pending <span className="count">{totalPending}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {networkError && (
                            <div
                                className="alert alert-danger d-flex align-items-center mb-4"
                                role="alert"
                                style={{ borderRadius: "8px" }}
                            >
                                <i className="fas fa-exclamation-triangle me-3 fs-5"></i>
                                <div className="flex-grow-1">
                                    <strong>Connection Error</strong>
                                    <p className="mb-0 mt-1 small">{networkError}</p>
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-outline-danger mt-2"
                                        onClick={() => getData()}
                                    >
                                        Retry
                                    </button>
                                </div>
                            </div>
                        )}

                        {/* Table */}
                        <div className="card table-card border-0">
                            <div className="card-body p-0">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="table-responsive">
                                            <table className="table table-hover mb-0">
                                                <thead>
                                                    <tr>
                                                        {(activeTab === "pending" || activeTab === "rejected") && (
                                                            <th style={{ width: 40, textAlign: "center" }}>
                                                                <input
                                                                    ref={headerChkRef}
                                                                    type="checkbox"
                                                                    className="chk-box"
                                                                    onChange={toggleSelectAll}
                                                                    aria-label={`Select all ${activeTab}`}
                                                                />
                                                            </th>
                                                        )}
                                                        <th>Index</th>
                                                        <th>Client</th>
                                                        <th>Contact</th>
                                                        {activeTab === "all" && <th>Status</th>}
                                                        <th>UCC</th>
                                                        <th style={{ width: 100 }}>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {loading ? (
                                                        <tr>
                                                            <td colSpan={activeTab === "pending" || activeTab === "rejected" ? 6 : 5} className="text-center py-5 text-muted">
                                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                                Loading users...
                                                            </td>
                                                        </tr>
                                                    ) : currentItems.length === 0 ? (
                                                        <tr>
                                                            <td colSpan={activeTab === "pending" || activeTab === "rejected" ? 6 : 5} className="text-center py-5 text-muted">
                                                                No users found
                                                            </td>
                                                        </tr>
                                                    ) : (
                                                        currentItems.map((dataa, idx) => {
                                                            const uid = getId(dataa);
                                                            const isSelected = uid
                                                                ? selectedIds.includes(uid)
                                                                : false;

                                                            const uccRaw = dataa?.ucc ?? dataa?.UCC ?? null;
                                                            const uccEmpty =
                                                                uccRaw === null ||
                                                                uccRaw === undefined ||
                                                                (typeof uccRaw === "string" &&
                                                                    uccRaw.trim() === "");

                                                            const rejected = isRejectedUser(dataa);

                                                            let statusLabel = "Pending";
                                                            if (rejected) statusLabel = "Rejected";
                                                            else if (!uccEmpty) statusLabel = "Approved";

                                                            return (
                                                                <tr key={uid ?? idx}>
                                                                    {(activeTab === "pending" ||
                                                                        activeTab === "rejected") && (
                                                                            <td style={{ width: 48, textAlign: "center" }}>
                                                                                <input
                                                                                    type="checkbox"
                                                                                    className="chk-box"
                                                                                    checked={!!isSelected}
                                                                                    onChange={() => toggleRow(uid)}
                                                                                    aria-label={`Select user ${uid}`}
                                                                                />
                                                                            </td>
                                                                        )}
                                                                    <td className="text-muted">{indexOfFirstItem + idx + 1}</td>
                                                                    <td>
                                                                        <div className="d-flex align-items-center">
                                                                            <div className="rounded-circle me-3 flex-shrink-0 d-flex align-items-center justify-content-center overflow-hidden" style={{ width: 40, height: 40, background: "#e6f6f5", color: "#19bcb8" }}>
                                                                                {dataa?.photo ? (
                                                                                    <img
                                                                                        src={`${process.env.REACT_APP_BACKEND_BASE_URL_FILES}${dataa.photo}`}
                                                                                        alt=""
                                                                                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                                                                        onError={(e) => {
                                                                                            e.target.style.display = "none";
                                                                                            e.target.nextElementSibling?.classList.remove("d-none");
                                                                                        }}
                                                                                    />
                                                                                ) : null}
                                                                                <i className={`fas fa-user ${dataa?.photo ? "d-none" : ""}`}></i>
                                                                            </div>
                                                                            <div>
                                                                                <div className="fw-semibold text-dark">{`${dataa.first_name || ""} ${dataa.last_name || ""}`.trim() || "-"}</div>
                                                                                <div className="small text-muted">{dataa.pan_number || dataa.email || ""}</div>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div className="small">{dataa.email || "-"}</div>
                                                                        <div className="small text-muted">{(dataa.country_code || "") + (dataa.phone || dataa.mobile || "") || "-"}</div>
                                                                    </td>
                                                                    {activeTab === "all" && (
                                                                        <td>
                                                                            <span className={`status-badge status-${statusLabel.toLowerCase()}`}>
                                                                                {statusLabel}
                                                                            </span>
                                                                        </td>
                                                                    )}
                                                                    <td><code className="bg-light px-2 py-1 rounded" style={{ fontSize: "0.85rem" }}>{dataa.ucc ?? dataa.UCC ?? "-"}</code></td>
                                                                    <td>
                                                                        <ActionsDropdown user={dataa} uccRaw={uccRaw} uccEmpty={uccEmpty} rejected={rejected} />
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                {/* Pagination */}
                                {pageCount > 1 && (
                                    <nav className="d-flex align-items-center justify-content-between flex-wrap gap-3 p-4 border-top bg-light" aria-label="Table pagination">
                                        <div className="d-flex align-items-center gap-2">
                                            <span className="small text-muted">Rows per page</span>
                                            <select
                                                className="form-select form-select-sm"
                                                style={{ width: "70px" }}
                                                value={itemsPerPage}
                                                onChange={handleItemsPerPageChange}
                                            >
                                                <option value="10">10</option>
                                                <option value="20">20</option>
                                                <option value="30">30</option>
                                                <option value="40">40</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                                <option value="150">150</option>
                                            </select>
                                        </div>
                                        <ReactPaginate
                                            breakLabel="..."
                                            nextLabel="Next"
                                            onPageChange={handlePageClick}
                                            forcePage={currentPage}
                                            pageCount={pageCount}
                                            previousLabel="Previous"
                                            renderOnZeroPageCount={null}
                                            containerClassName="pagination"
                                            pageClassName="page-item"
                                            pageLinkClassName="page-link"
                                            previousClassName="page-item"
                                            previousLinkClassName="page-link"
                                            nextClassName="page-item"
                                            nextLinkClassName="page-link"
                                            breakClassName="page-item"
                                            breakLinkClassName="page-link"
                                            activeClassName="active"
                                        />
                                    </nav>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default UsersList;